angular.module('gym.contacts').controller('AddGoCardlessPaymentMethodCtrl', ["$scope", "$modalInstance", "loadingAnimation", "flash", "gym", "contact", "redirectUrl", function($scope, $modalInstance, loadingAnimation, flash, gym, contact, redirectUrl) {
  $scope.gym = gym;
  $scope.contact = contact;
  $scope.redirectUrl = redirectUrl.gocardless_url;
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
